<template>
  <div class="pulse-palpated-check">
    <md-chip class="md-primary">If pulse was palpated at</md-chip>
    <el-select
      v-close-on-zoom
      :value="state.locations"
      placeholder="Any locations"
      class="pulse-location-select"
      :disabled="readonly"
      :multiple="true"
      @input="(locations) => setLocations(locations)"
    >
      <el-option
        v-for="locations in pulseLocations"
        :key="locations.key"
        :label="locations.label.en"
        :value="locations.key"
      />
      <el-option label="Central" value="ANY_CENTRAL" />
      <el-option label="Peripheral" value="ANY_PERIPHERAL" />
    </el-select>
  </div>
</template>

<script>
import get from 'lodash/get';

import pulseLocations from '~lib/common/config/pulseLocations';

export default {
  name: 'pulse-palpated-check',
  props: ['readonly', 'emitter', 'ikey', 'getData', 'putData', 'control'],
  data() {
    return {
      state: {
        locations: [],
      },
      pulseLocations,
    };
  },
  mounted() {
    const data = this.getData(this.ikey);
    this.state.locations = get(data, 'ids') || [];
    this.state.strength = get(data, 'value') || true;
    this.update();
  },
  methods: {
    setLocations(locations) {
      this.state.locations = locations;
      this.update();
    },
    update() {
      this.putData(this.ikey, {
        type: 'PULSE_PALPATED',
        ids: this.state.locations,
        operator: 'EQUAL',
        value: true,
      });
      this.emitter.trigger('process', this.control);
    },
  },
};
</script>

<style scoped>
.pulse-palpated-check {
  display: flex;
  align-items: center;
}
</style>